<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Por ubicación
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span class="grey-text">Reportes</span>
      <span> /</span>
      <span>Por ubicación</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsUbicacion" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Ubicación" formControlName="ubicacion"></mdb-select>
            <label>Ubicación</label>
          </div>
        </div>

        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsEstado" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Estado" formControlName="estado"></mdb-select>
            <label>Estado</label>
          </div>
        </div>
        <!-- <div class="col">
          <mdb-checkbox formControlName="incluirClientesSinVentas">Incluir clientes sin ventas</mdb-checkbox>
        </div> -->
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">

    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

    <div class="table-responsive" *ngIf="listaMaquinas">

      <app-no-data-alert *ngIf="listaMaquinas?.length === 0">
      </app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMaquinas?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Ubicación</th>
            <th scope="col">Estado</th>
            <th scope="col">Cantidad de Máquinas</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let mov of listaMaquinas">
            <td>{{mov.ubicacion}}</td>
            <td>{{mov.estado_maquina_nombre}}</td>
            <td>{{mov.conteo | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMaquinas?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMaquinas?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm" (click)="downloadExcelPdf('PDF')">
      PDF
    </button>
  </div>
</div>
